import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getLocaleFromUrl } from '../helpers/getLocale';
import { usePublicConfig } from '../firebase/hooks';
import { useNonNullableContext } from '../hooks/useNonNullableContext';
import { WizardContext } from '../contexts/WizardContext/WizardContext';
import { fallbackLanguageSettings } from '../../../../functions/src/shared';

export const useLanguageUrlSegment = () => {
  const { setWizardData, language } = useNonNullableContext(WizardContext);
  const languageSettings = usePublicConfig().languageSettings || fallbackLanguageSettings;
  const history = useHistory();

  useEffect(() => {
    const localeFromUrl = getLocaleFromUrl();
    if (localeFromUrl && language !== localeFromUrl) {
      if (languageSettings.additionalLanguages.includes(localeFromUrl)) {
        setWizardData({ language: localeFromUrl });
      } else {
        history.push('/error');
      }
    }
  }, [language, languageSettings, history, setWizardData]);
};
